import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Phone, Building2 } from "lucide-react";

const FILTERS = [["new", "New"], ["contacted", "Contacted"], ["closed", "Closed"], ["", "All"]];

export function AdminEnquiries() {
  const [filter, setFilter] = useState("new");
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/admin/enquiries", { params: { status: filter || undefined } }).then((r) => setData(r.data)), [filter]);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/enquiries/${id}`, { status }); toast.success(`Marked ${status}`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not update"); }
  };

  return (
    <div data-testid="admin-enquiries">
      <div className="mb-5 flex flex-wrap gap-2">
        {FILTERS.map(([k, l]) => (
          <button key={l} onClick={() => setFilter(k)} data-testid={`enquiry-filter-${l.toLowerCase()}`}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${filter === k ? "bg-[#0D5C3A] text-white" : "bg-white/5 text-stone-300 hover:bg-white/10"}`}>
            {l}{k && data?.counts ? ` (${data.counts[k]})` : ""}
          </button>
        ))}
      </div>
      {!data ? <p className="text-sm text-stone-400">Loading…</p> : data.enquiries.length === 0 ? (
        <p className="rounded-2xl border border-white/10 bg-[#0b1322] p-8 text-center text-sm text-stone-400" data-testid="enquiries-empty">No enquiries here yet.</p>
      ) : (
        <div className="space-y-3">
          {data.enquiries.map((e) => <EnquiryRow key={e.id} e={e} onStatus={setStatus} />)}
        </div>
      )}
    </div>
  );
}

function EnquiryRow({ e, onStatus }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0b1322] p-5" data-testid={`enquiry-${e.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="font-heading text-base font-bold">{e.name} <span className="font-normal text-stone-400">· {e.business_name}</span></p>
          <p className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-xs text-stone-400">
            <span className="inline-flex items-center gap-1"><Building2 className="h-3.5 w-3.5" /> {e.business_type}</span>
            <a href={`tel:${e.phone}`} className="inline-flex items-center gap-1 hover:text-white"><Phone className="h-3.5 w-3.5" /> {e.phone}</a>
            <a href={`mailto:${e.email}`} className="inline-flex items-center gap-1 hover:text-white"><Mail className="h-3.5 w-3.5" /> {e.email}</a>
            <span>{new Date(e.created_at).toLocaleString()}</span>
          </p>
        </div>
        <select value={e.status} onChange={(ev) => onStatus(e.id, ev.target.value)} data-testid={`enquiry-status-${e.id}`}
          className="rounded-lg border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-stone-200">
          <option value="new">New</option><option value="contacted">Contacted</option><option value="closed">Closed</option>
        </select>
      </div>
      <p className="mt-3 whitespace-pre-wrap text-sm text-stone-300">{e.message}</p>
    </div>
  );
}
